<template>
  <div class="fixed h-14 w-screen bg-gray-900 top-0 z-10">
    <div class="max-w-full flex flex-wrap items-center justify-between w-full text-white">
      <div class="h-14 flex flex-row items-center">
        <img src="@/assets/Logo-CST.png" alt="Logo" class="h-10 w-auto ml-2 mr-8" />
        <a href="/" class="flex items-center">
          <span class="self-center text-xl p-3 font-semibold text-white whitespace-nowrap dark:text-white mr-4 h-full flex items-center">Home</span>
        </a>
        <span class="text-gray-400 mr-4 h-full flex items-center">
          {{ userName }}
        </span>
        <DataViewSmall
        class="h-full flex items-center mr-4"
          @openChangeView="openChangeView()"
        />
      </div>
      <button
        class="inline-flex items-center p-3 ml-3 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
        type="button"
        data-collapse-toggle="navbar-multi-level"
        aria-controls="navbar-multi-level"
        aria-expanded="false"
        @click="onSmallScreenExpandClick">
        <span class="sr-only">Open main menu</span>
        <svg
          class="w-6 h-6"
          aria-hidden="true"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd"></path>
        </svg>
      </button>
      <div class="w-full md:block md:w-auto md:max-h-14"
        :class="{
          'hidden': smallScreenHidden
        }"
        id="navbar-multi-level">
        <ul class="flex flex-col font-medium self-center items-center md:p-0 mt-2 md:flex-row mr-3 md:space-x-6 md:mt-0 flex items-center justify-center">
          <NavbarDropdown
            ref="pagesNavbarDropdown"
            :disabled="!enablePageDropdown"
            :title="displayPageDropdown">
            <template #menuItems>
              <li v-if="showStudentList"
                @click="onPageSelected">
                <router-link class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                  to="/StudentList">Student List
                </router-link>
              </li>
              <li v-if="showRouteList"
                @click="onPageSelected">
                <router-link class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                  to="/RouteList">Route List
                </router-link>
              </li>
              <li v-if="showRequestForm"
                @click="onPageSelected">
                <router-link class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                  to="/NewRequestForm">New Request Form
                </router-link>
              </li>
              <li v-if="showOneTimeNoRideList"
                @click="onPageSelected">
                <router-link class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                  to="/OneTimeNoRideList">One Time No Ride List
                </router-link>
              </li>
              <li v-if="showDailyNoShowList"
                @click="onPageSelected">
                <router-link class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                  to="/DailyNoShowList">Daily No Show List
                </router-link>
              </li>
              <li v-if="showEventList"
                @click="onPageSelected">
                <router-link class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                  to="/EventList">Event List
                </router-link>
              </li>
              <li v-if="showCalendarForm"
                @click="onPageSelected">
                <router-link class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                  to="/CalendarForm">Event Form
                </router-link>
              </li>
              <li v-if="showDriverList"
                @click="onPageSelected">
                <router-link class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                  to="/DriverList">Driver List
                </router-link>
              </li>
              <li v-if="showVehicleList"
                @click="onPageSelected">
                <router-link class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                  to="/VehicleList">Vehicle List
                </router-link>
              </li>
              <li v-if="showVendorForms"
                @click="onPageSelected">
                <router-link class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                  to="/VendorForms">Vendor Forms
                </router-link>
              </li>
              <li v-if="showVendorForms"
                @click="onPageSelected">
                <router-link class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                  to="/CalendarEmbed">Calendar
                </router-link>
              </li>
              <li v-if="showLateRouteForm"
                @click="onPageSelected">
                <router-link class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                  to="/LateRouteForm">Late Route Form
                </router-link>
              </li>
              <li v-if="showDailyNoShowForm"
                @click="onPageSelected">
                <router-link class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                  to="/DailyNoShowForm">Daily No-show Form
                </router-link>
              </li>
              <li v-if="showOneTimeRide"
                @click="onPageSelected">
                <router-link class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                  to="/OneTimeRide">One-Time Ride Request Form
                </router-link>
              </li>
              <li v-if="showUserManagementSync"
                @click="onPageSelected">
                <router-link class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                  to="/UserManagementSync">User Management Page
                </router-link>
              </li>
            </template>
          </NavbarDropdown>
          <NavbarDropdown
            title="Settings">
            <template #menuItems>
              <li v-if="showStudentListSettings">
                <button
                  id="doubleDropdownButton"
                  data-dropdown-toggle="doubleDropdown"
                  data-dropdown-placement="right-start"
                  type="button"
                  class="flex items-center justify-between w-full px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                  @click="onListPageSettingsSelected($event.target)">
                  List Pages
                </button>
              </li>
              <div class="py-1">
                <button
                  class="w-full text-left block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  @click="onClickSignOut">
                  Sign out
                </button>
              </div>
            </template>
          </NavbarDropdown>
        </ul>
      </div>
    </div>
    <Notifications />
    <ChangeView
      ref="changeViewModal"
    />
    <Modal ref="changeRoleModal" size="sm" anchor="top" overflow>
      <template #title>
        <h3 class="p-2 text-center mx-auto">Operations Settings</h3>
      </template>
      <template #content>
        <operations-settings-form
          id="operationsSettingsForm"
          ref="operationsSettingsForm"
          :roleInfo="user.userData.meta_info"
        />
      </template>
      <template #footer="slotProps">
        <button
          type="button"
          class="rounded-md font-medium text-green-900 bg-green-100 px-3 py-2 hover:bg-green-200 transition-colors shadow-sm"
          @click="
            () => {
              if ($refs.operationsSettingsForm.onSubmit()) {
                slotProps.closeModal(true)
              }
            }
          ">
          Save
        </button>
      </template>
    </Modal>
    <Modal ref="listPageSettingsModal" size="sm" anchor="top" overflow>
      <template #title>
        <h3 class="p-2 text-center mx-auto">Student List Settings</h3>
      </template>
      <template #content>
        <student-list-settings-form
          id="studentListSettingsForm"
          ref="studentListSettingsForm"
        />
      </template>
      <template #footer="slotProps">
        <SubmitButton
          type="button"
          class="rounded-md font-medium text-green-900 bg-green-100 px-3 py-2 hover:bg-green-200 transition-colors shadow-sm"
          @click="
            () => {
              if ($refs.studentListSettingsForm.onSubmit()) {
                slotProps.closeModal(true)
              }
            }
          ">
          Save
        </SubmitButton>
      </template>
    </Modal>
  </div>
</template>

<script>
import OperationsSettingsForm from './OperationsSettingsForm.vue'
import StudentListSettingsForm from './StudentListSettingsForm.vue'
import NavbarDropdown from './NavBar/NavbarDropdown.vue'
import ChangeView from './NavBar/ChangeView/ChangeView.vue'
import Modal from './Modal.vue'
import Notifications from './Notifications.vue'
import DataViewSmall from './NavBar/DataViewSmall/DataViewSmall.vue'
import SubmitButton from './SubmitButton.vue'

import events from '../services/events.js'

import user from '../services/user/user.js'
import { default as auth0User } from '../services/auth0/user.js'


export default {
  components: {
    OperationsSettingsForm,
    StudentListSettingsForm,
    NavbarDropdown,
    ChangeView,
    Modal,
    Notifications,
    DataViewSmall,
    SubmitButton,
  },
  props: {},
  data() {
    return {
      user: undefined,
      userName: '',
      showChangeRole: false,
      smallScreenHidden: true,
    }
  },
  eventCallbackIds: {},
  methods: {
    async updateUser() {
      this.user = await user.get()

      this.userName = this.user.getFirstName() + ' ' + this.user.getLastName()
    },
    openChangeView() {
      this.$refs.changeViewModal.openModal()
    },
    onListPageSettingsSelected() {
      this.$refs.listPageSettingsModal.openModal()
    },
    onSmallScreenExpandClick() {
      this.smallScreenHidden = !this.smallScreenHidden
    },
    onPageSelected() {
      this.$refs.pagesNavbarDropdown.closeMenu()
    },
    onClickSignOut() {
      if (auth0User.isEnabled()) {
        events.trigger('showLoginOverlay')
        //    Or this for 1-click logout
        // auth0User.get().then(auth0Client => {
        //   auth0Client.logout()
        // })
      }
      else {
        window.location.href = '/login?action=logout'
      }
    },
  },
  computed: {
    countAvailablePages() {
      let availablePages = [
        this.showStudentList,
        this.showRouteList,
        this.showOneTimeNoRideList,
        this.showDailyNoShowList,
        this.showRequestForm,
        this.showLateRouteForm,
        this.showDailyNoShowForm,
        this.showOneTimeRide,
        this.showVendorForms,
        this.showUserManagementSync,
        this.showCalendarForm,
        this.showEventList,
        this.showDriverList,
        this.showVehicleList,
      ]
      const count = availablePages.filter(Boolean).length
      return count
    },
    enablePageDropdown() {
      let value = this.countAvailablePages > 0
      events.trigger('enableUserNotAllowedError', !value)
      return value
    },
    displayPageDropdown() {
      return (this.enablePageDropdown)
        ? 'Pages'
        : 'No Pages Available'
    },
    showStudentList() {
      if (this.user === undefined) return false

      return this.user.can('view_student_list')
    },
    showRouteList() {
      if (this.user === undefined) return false

      return this.user.can('view_route_list')
    },
    showOneTimeNoRideList() {
      if (this.user === undefined) return false

      return this.user.can('view_one_time_no_ride_list')
    },
    showDailyNoShowList() {
      if (this.user === undefined) return false

      return this.user.can('view_daily_no_show_list')
    },
    showRequestForm() {
      if (this.user === undefined) return false

      return this.user.can('view_new_request_form')
    },
    showLateRouteForm() {
      if (this.user === undefined) return false

      return this.user.can('view_late_route_form')
    },
    showDailyNoShowForm() {
      if (this.user === undefined) return false

      return this.user.can('view_daily_no_show_form')
    },
    showOneTimeRide() {
      return false

      // if (this.user === undefined) return false
      // return this.user.can('view_one_time_ride')
    },
    showVendorForms() {
      if (this.user === undefined) return false

      return this.user.can('view_vendor_forms')
    },
    showUserManagementSync() {
      if (this.user === undefined) return false

      return this.user.can('view_user_management')
    },
    showCalendarForm() {
      if (this.user === undefined) return false

      return this.user.can('view_calendar_event')
    },
    showEventList() {
      if (this.user === undefined) return false

      return this.user.can('view_event_list')
    },
    showDriverList() {
      if (this.user === undefined) return false

      return this.user.can('view_driver_list')
    },
    showVehicleList() {
      if (this.user === undefined) return false

      return this.user.can('view_vehicle_list')
    },
    showStudentListSettings() {
      if (this.user === undefined) return false

      return this.user.can('view_student_list')
    },
  },
  created() {
    // this.$options.eventCallbackIds.operationsSettingsFormUpdate = events.register(
    //   'operationsSettingsFormUpdate',
    //   () => {
    //     this.updateUser()
    //   }
    // )
    // this.$options.eventCallbackIds.partitionDropdownUpdate = events.register(
    //   'partitionDropdownUpdate',
    //   () => {
    //     this.$refs.userDisplay.markDistrictSelectionDisplay()
    //   }
    // )
    this.updateUser()
  },
  //beforeUnmount() {
  // eslint-disable-next-line
  beforeDestroy() {
    // events.remove(
    //   'operationsSettingsFormUpdate',
    //   this.$options.eventCallbackIds.operationsSettingsFormUpdate
    // )
    // events.remove(
    //   'partitionDropdownUpdate',
    //   this.$options.eventCallbackIds.partitionDropdownUpdate
    // )
  }
}
</script>
